import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { userService, USER_ID_KEY } from './services/userService';
import { UserProfile } from './types/user';
import './HomePage.css';

const QUIZZES = [
  { to: '/quiz',        icon: '🥋', title: 'Pensum Quiz',  desc: 'Test dit pensum bælteviden' },
  { to: '/Words',       icon: '🈶', title: 'Ord Quiz',     desc: 'Multiple-choice japanske ord' },
  { to: '/WrittenQuiz', icon: '✍️',  title: 'Skrive Quiz', desc: 'Skriv de japanske ord' },
];

const LOOKUPS = [
  { to: '/pensum',     icon: '📋', title: 'Pensum',      desc: 'Gennemse alle teknikker' },
  { to: '/WordSearch', icon: '🔍', title: 'Ord Søgning', desc: 'Søg i japansk-dansk ordbog' },
  { to: '/Kata',       icon: '🎌', title: 'Kata',        desc: 'Dan-niveau kata teknikker' },
];

function hoursSince(dateStr: string): number {
  return (Date.now() - new Date(dateStr).getTime()) / 3_600_000;
}

function HomePage() {
  const [user, setUser] = useState<UserProfile | null>(null);

  useEffect(() => {
    const userId = localStorage.getItem(USER_ID_KEY);
    if (!userId) return;
    userService.getUser(userId).then(setUser).catch(() => {});
  }, []);

  const hours = user?.lastTrainingDate ? hoursSince(user.lastTrainingDate) : null;
  const streakActive = hours !== null && hours > 12 && hours < 24;

  return (
    <div className="homepage-container">
      {user && (
        <div className={`streak-banner${streakActive ? ' streak-banner--active' : ' streak-banner--inactive'}`}>
          <span className="streak-flame">{streakActive ? '🔥' : '💤'}</span>
          <div className="streak-text">
            <span className="streak-warning">
              {streakActive ? 'Stræk din streak!' : 'Ingen aktiv streak'}
            </span>
            <span className="streak-sub">
              {streakActive
                ? `Du har ikke trænet i ${Math.floor(hours!)} timer`
                : 'Træn i dag for at starte en streak'}
            </span>
          </div>
          <div className="streak-xp">
            <span className="streak-xp-value">{user.totalXp}</span>
            <span className="streak-xp-label">XP</span>
          </div>
        </div>
      )}

      <div className="homepage-logo">🥋</div>
      <h1 className="homepage-title">Judo<span>lingo</span></h1>
      <p className="homepage-subtitle">Lær judo — én teknik ad gangen</p>

      <div className="nav-section">
        <p className="nav-section-label">Quizzer</p>
        <div className="nav-grid">
          <Link to="/Judolingo" className="nav-card nav-card--featured">
            <span className="nav-card-icon">⚡</span>
            <div>
              <div className="nav-card-title">Judolingo</div>
              <div className="nav-card-desc">Blandet quiz — 35 spørgsmål, 3 modes</div>
            </div>
          </Link>
          {QUIZZES.map(({ to, icon, title, desc }) => (
            <Link key={to} to={to} className="nav-card">
              <span className="nav-card-icon">{icon}</span>
              <div className="nav-card-title">{title}</div>
              <div className="nav-card-desc">{desc}</div>
            </Link>
          ))}
        </div>
      </div>

      <div className="nav-section">
        <p className="nav-section-label">Opslagsværk</p>
        <div className="nav-grid">
          {LOOKUPS.map(({ to, icon, title, desc }) => (
            <Link key={to} to={to} className="nav-card">
              <span className="nav-card-icon">{icon}</span>
              <div className="nav-card-title">{title}</div>
              <div className="nav-card-desc">{desc}</div>
            </Link>
          ))}
        </div>
      </div>

      <Link to="/login" className="nav-card nav-card--profile">
        <span className="nav-card-icon">👤</span>
        <div>
          <div className="nav-card-title">Min Profil</div>
          <div className="nav-card-desc">XP, fremskridt og daglig træning</div>
        </div>
      </Link>

      <div className="info-notice">
        Billedmateriale tilhører Dansk Judo &amp; Ju-Jitsu Union (DJU).<br />
        © Dansk Judo &amp; Ju-Jitsu Union. Alle rettigheder forbeholdes.<br />
        <strong>Denne app er ikke officielt tilknyttet DJU.</strong>
      </div>
    </div>
  );
}

export default HomePage;
